function amountValidator({ configs, input, msgs }) {
  const rule = /^\d*\.?\d{0,2}$/;
  const locale = 'en-US';
  const localeOptions = {
    currency: 'USD',
    style: 'currency',
  };

  const cleanInput = input.toString().replace(/,/g, '');

  if (!rule.test(cleanInput)) {
    if (msgs && msgs.amount) {
      return msgs.amount;
    }
    return 'Please enter a valid amount.';
  }

  if (configs) {
    let minValue = configs.min;
    let maxValue = configs.max;

    if (Object.prototype.hasOwnProperty.call(configs, 'productMin')) {
      minValue = configs.productMin;
    }

    if (Object.prototype.hasOwnProperty.call(configs, 'productMax')) {
      maxValue = configs.productMax;
    }

    if (minValue && parseFloat(cleanInput) < parseFloat(minValue)) {
      if (msgs && msgs.min) {
        return msgs.min.replace('%s', parseFloat(minValue).toLocaleString(locale, localeOptions));
      }
      return `Amount must be greater than or equal to ${parseFloat(minValue).toLocaleString(
        locale,
        localeOptions,
      )}.`;
    }

    if (maxValue && parseFloat(cleanInput) > parseFloat(maxValue)) {
      if (msgs && msgs.max) {
        return msgs.max.replace('%s', parseFloat(maxValue).toLocaleString(locale, localeOptions));
      }
      return `Amount must be less than or equal to ${parseFloat(maxValue).toLocaleString(
        locale,
        localeOptions,
      )}.`;
    }

    if (
      maxValue &&
      parseFloat(cleanInput) > parseFloat(maxValue) &&
      maxValue &&
      parseFloat(cleanInput) < parseFloat(minValue)
    ) {
      if (msgs && msgs.minmax) {
        return msgs.minmax
          .replace('%s', parseFloat(minValue).toLocaleString(locale, localeOptions))
          .replace('%s', parseFloat(maxValue).toLocaleString(locale, localeOptions));
      }
      return `Amount must be between ${parseFloat(minValue).toLocaleString(
        locale,
        localeOptions,
      )} and ${parseFloat(maxValue).toLocaleString(locale, localeOptions)}.`;
    }
  }

  return null;
}

export default amountValidator;
